import { Box, Text, Flex, chakra } from "@chakra-ui/react";
import { colours } from "@shared/ui.design-system";

const sharedStyles = {
  position: "absolute",
  top: "0",
  left: "0",
  right: "0",
  bottom: "0",
  overflow: "hidden",
  userSelect: "none"
};

export const BeforeAfterContainer = chakra(Flex, {
  baseStyle: {
    width: "100%",
    height: { base: "25rem", md: "27.5rem", lg: "24.125rem" },
    flexWrap: "wrap",
    justifyContent: "space-around",
    flexDirection: "row",
    alignItems: "stretch",
    alignContent: "stretch",
    userSelect: "none"
  }
});

export const BeforeAfterBox = chakra(Box, {
  baseStyle: {
    pos: "relative",
    cursor: "grab",
    overflow: "hidden",
    width: "100%",
    height: "100%",
    userSelect: "none"
  }
});

export const BeforeAfterImageContainer = chakra(Box, {
  baseStyle: {
    ...sharedStyles,
    height: { base: "25rem", md: "27.5rem", lg: "24.125rem" }
  }
});

export const BeforeImageContainer = chakra(Box, {
  baseStyle: {
    ...sharedStyles,
    height: "100%"
  }
});

export const SliderThumb = chakra(Box, {
  baseStyle: {
    height: "31px",
    width: "31px",
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
    border: `2px solid ${colours.secondary.light}`,
    borderRadius: "20px",
    pointerEvents: "none",
    userSelect: "none",
    "&:before": {
      content: "''",
      display: "block",
      width: "4px",
      background: colours.secondary.light,
      height: { base: "25rem", md: "27.5rem", lg: "24.125rem" },
      position: "absolute",
      left: "50%",
      marginLeft: "-2.5px",
      bottom: "50%",
      marginBottom: "15px"
    },
    "&:after": {
      content: "''",
      display: "block",
      width: "4px",
      background: colours.secondary.light,
      height: { base: "25rem", md: "27.5rem", lg: "24.125rem" },
      position: "absolute",
      left: "50%",
      marginLeft: "-2.5px",
      top: "50%",
      marginTop: "15px"
    }
  }
});

const sliderThumbArrowStyles = {
  width: "0",
  height: "0",
  border: "4px inset transparent",
  position: "absolute",
  top: "50%",
  marginTop: "-4px",
  left: "50%"
};

export const SliderThumbLeftArrow = chakra(Text, {
  baseStyle: {
    ...sliderThumbArrowStyles,
    borderRight: `4px solid ${colours.secondary.light}`,
    marginLeft: "-10px"
  }
});

export const SliderThumbRightArrow = chakra(Text, {
  baseStyle: {
    ...sliderThumbArrowStyles,
    borderLeft: `4px solid ${colours.secondary.light}`,
    marginLeft: "1px"
  }
});

export const CopyBox = chakra(Box, {
  baseStyle: {
    position: "absolute",
    top: { base: "22.5rem", md: "23.75rem", lg: "20.625rem" },
    left: "0",
    backgroundColor: colours.secondary.light,
    borderRadius: "3px",
    textAlign: "center",
    p: "0.3125rem 0.625rem",
    w: { base: "3.625rem", lg: "4.063rem" }
  }
});

export const Copy = chakra(Text, {
  baseStyle: {
    mt: 0,
    fontSize: { base: -4, lg: 1 }
  }
});
